export default __webpack_public_path__ + "static/media/ERI_Schedule.80e852aa.pdf";